import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileSticky from "../components/MobileSticky";
import Testimonials from "../components/Testimonials";
import Seo, { localBusinessSchema } from "../components/Seo";
import { TESTIMONIALS, COMPANY } from "../data/site";
import { Star } from "lucide-react";

export default function Reviews() {
  return (
    <div data-testid="page-reviews">
      <Seo
        title="Reviews — Connolly's Painting Solutions"
        description="Client reviews from across the Sunshine Coast. Average rating 4.9/5 from over 100 painting projects."
        path="/reviews"
        schema={[localBusinessSchema(COMPANY, { reviews: TESTIMONIALS })]}
      />
      <Header />

      <section className="section bg-[#F9F8F6]">
        <div className="container-cps">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-end">
            <div className="md:col-span-8">
              <div className="overline">Reviews</div>
              <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">What our clients say.</h1>
            </div>
            <div className="md:col-span-4 text-right">
              <div className="flex md:justify-end gap-1">
                {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={20} fill="#C5A059" stroke="#C5A059" />)}
              </div>
              <div className="mt-3 font-display text-4xl text-[#0B1426]">4.9 / 5</div>
              <div className="text-xs uppercase tracking-wider text-[#4F5B6A] mt-1">137+ Verified reviews</div>
            </div>
          </div>

          <div className="mt-16">
            <Testimonials />
          </div>

          <div className="mt-20 text-center">
            <p className="text-[#4F5B6A]">Loved working with us? <a className="text-link text-[#0B1426] font-medium" href="https://g.page/r/" target="_blank" rel="noreferrer">Leave us a Google review →</a></p>
            <Link to="/quote" className="btn-gold mt-8" data-testid="reviews-cta-quote">Start your project</Link>
          </div>
        </div>
      </section>

      <Footer />
      <MobileSticky />
    </div>
  );
}
